import React from "react";
import Page from "../../components/Page";

import CenteredPageContentContainer from "../../components/CenteredPageContentContainer";
import PaperContainer from "../../components/PaperContainer";
import ActiveShiftList from "../../components/ActiveShiftList";

const ActiveShiftsPage = () => (
  <Page title="Dienstaanvragen">
    <CenteredPageContentContainer>
      <PaperContainer title="Dienstaanvragen">
        <ActiveShiftList />
      </PaperContainer>
    </CenteredPageContentContainer>
  </Page>
);

export default ActiveShiftsPage;



// WEBPACK FOOTER //
// ./src/pages/Shift/ActiveShiftsPage.js